import { useQuery } from "@tanstack/react-query";
import { apiCall } from "../lib/apiClient";

/** Princip #4: čerstvost dat střediska (kompletní/částečný + čas). */

export interface TenantSyncStatus {
  state: string | null;
  last_sync_at: string | null;
  inventory_count: number | null;
  complete: boolean;
}

export function useTenantSyncStatus() {
  return useQuery({
    queryKey: ["tenant", "sync-status"] as const,
    queryFn: () => apiCall<TenantSyncStatus>("/api/tenant/sync-status"),
    staleTime: 30_000,
  });
}
